import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export function AttendanceGuage({ percentage }: { percentage: number }) {
  return (
    <CircularProgressbarWithChildren
      value={percentage}
      backgroundPadding={24}
      strokeWidth={5}
      counterClockwise
      styles={{
        // Customize the root svg element
        // root: {},
        // Customize the path, i.e. the "completed progress"
        path: {
          // Path color
          stroke: `#FF6600`,
          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: 'butt',
          // Customize transition animation
          transition: 'stroke-dashoffset 0.5s ease 0s',
          // Rotate the path
          // transform: 'rotate(0.25turn)',
          transformOrigin: 'center center'
        },
        // Customize the circle behind the path, i.e. the "total progress"
        trail: {
          // Trail color
          stroke: '#ffffff',
          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: 'butt',
          // Rotate the trail
          // transform: 'rotate(0.25turn)',
          transformOrigin: 'center center'
        },
        // Customize the text
        // Customize background - only used when the `background` prop is true
        background: {
          fill: '#ffff'
        }
      }}
    >
      <div className="w-[70%] h-[70%] bg-primary drop-shadow-2xl rounded-full flex items-center justify-center">
        <p className="text-white font-bold">{percentage}%</p>
      </div>
    </CircularProgressbarWithChildren>
  );
}
